import React, { useEffect, useState } from 'react';
import useTabQueryParam from '../../hooks/useTabQueryParam';
import { useNavigate } from 'react-router-dom';
import { formatLongDate } from '../../utils/dateFormat';
import Table from '../../components/Table';
import { fetchCompanyHolidays } from './api';
import { safeApiCall } from '../../utils/apiHelpers';

const columns = [
  { key: 'date', title: 'Date' },
  { key: 'name', title: 'Holiday Name' },
];

const Holidays = ({ readOnly = false }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editHoliday, setEditHoliday] = useState(null);

  useEffect(() => {
    setLoading(true);
    safeApiCall(fetchCompanyHolidays)
      .then(data => {        
        if (data) {
          setData(data.map(holiday => ({
            id: holiday.id,
            date: holiday.holiday_date,
            name: holiday.holiday_name,
          })));
        } else {
          setData([]);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const openModal = (holiday = null) => {
    setEditHoliday(holiday);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setEditHoliday(null);
  };

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useTabQueryParam('tab', 'holidays');
  const TABS = [
    { key: 'members', label: 'Members', route: '' },
    { key: 'leave-policy', label: 'Leave Policy', route: 'leave-policy' },
    { key: 'holidays', label: 'Holidays', route: 'holidays' },
  ];

  const handleTabClick = (tabKey, route) => {
    setActiveTab(tabKey);
    navigate(`/company/${route}`);
  };

  return (
    <div>

      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Holidays</h2>
        {!readOnly && (
          <button className="bg-indigo-600 text-white px-4 py-2 rounded font-semibold" onClick={() => openModal()}>Add Holiday</button>
        )}
      </div>
      <Table columns={columns} data={data.map(h => ({...h, date: formatLongDate(h.date)}))} actions={row => (
        !readOnly && <>
          <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded mr-2" title="Edit" onClick={() => openModal(row)}><i className="fas fa-edit" /></button>
          <button className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded" title="Delete"><i className="fas fa-trash" /></button>
        </>
      )} />
      {!readOnly && modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 shadow-xl min-w-[320px]">
            <h3 className="text-lg font-bold mb-4">{editHoliday ? 'Edit Holiday' : 'Add Holiday'}</h3>
            {/* Modal form fields go here */}
            <div className="flex gap-4 mt-6">
              <button className="bg-indigo-600 text-white px-4 py-2 rounded" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
      {loading && <div className="text-center py-8">Loading...</div>}
    </div>
  );
};

export default Holidays;
